import { Components, Theme } from '@mui/material';

export const MuiCircularProgress: Components<Theme>['MuiCircularProgress'] = {
  styleOverrides: {
    root: ({ theme }) => {
      if (theme.featureFlags.panwRebrandStubYear) {
        return {
          color: theme.palette.interactive.highlight.default,
        };
      }

      return {};
    },
  },
};

export const MuiLinearProgress: Components<Theme>['MuiLinearProgress'] = {
  styleOverrides: {
    root: ({ theme }) => {
      if (theme.featureFlags.panwRebrandStubYear) {
        return {
          background: theme.palette.interactive.neutral.default,
        };
      }

      return {};
    },
    bar: ({ theme }) => {
      if (theme.featureFlags.panwRebrandStubYear) {
        return {
          background: theme.palette.interactive.highlight.default,
        };
      }

      return {};
    },
  },
};
